<div class="app-wrapper">
  <app-header></app-header>

  <div class="mat-body">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>
</div>
